module.exports = __webpack_public_path__ + "static/media/universal.8cfce2be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/universal.svg
// module id = 536
// module chunks = 0